import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, output, signal } from '@angular/core';
import { RouterModule } from '@angular/router';

import { Router } from '@angular/router';
import { IMAGE_URLS } from 'src/app/core/constants/image-source';
import { HeaderConfigurations } from 'src/app/core/interfaces/store-configuration.interface';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { UserService } from 'src/app/core/services/user/user.service';
import { Category } from 'src/app/shared/services/common-api.service';
import { HeaderLayout } from '../dynamic-header/dynamic-header.component';
import { MenuCollapseInnerComponent } from './menu-collapse-inner/menu-collapse-inner.component';
import { MenuCollapseComponent } from './menu-collapse/menu-collapse.component';

@Component({
  selector: 'webstore-dynamic-menu-collapse',
  templateUrl: './dynamic-menu-collapse.component.html',
  styleUrls: ['./dynamic-menu-collapse.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, MenuCollapseComponent, MenuCollapseInnerComponent],
  providers: [UserService, NotificationService]
})
export class DynamicMenuCollapseComponent {
  private router = inject(Router);
  private userService = inject(UserService);
  private notificationService = inject(NotificationService);

  private _selectedCategoryId = signal<string>('');
  private _selectedSubCategoryId = signal<string>('');

  readonly selectedCategoryId = this._selectedCategoryId.asReadonly();
  readonly selectedSubCategoryId = this._selectedSubCategoryId.asReadonly();
  readonly hasSelectedCategory = computed(() => !!this._selectedCategoryId());
  readonly hasSelectedSubCategory = computed(() => !!this._selectedSubCategoryId());

  readonly menuCollapseIcon = input<string>('');
  readonly categories = input<Category[]>([]);
  readonly headerConfigurations = input<HeaderConfigurations>({} as HeaderConfigurations);
  readonly headerLayout = input<string>('default');

  // Computed property to check if layout is headerLayout12
  readonly isLayout12 = computed(() => this.headerLayout() === HeaderLayout.headerLayout12);

  HeaderLayout = HeaderLayout; // Exposed enum to template
  IMAGE_URLS = IMAGE_URLS;

  // Update output to use Angular 20 output() function
  hideMenu$ = output<boolean>();

  categorySelected(id: string | undefined, e?: Event) {
    if (!id) { return; }
    // Toggle logic: if clicking same category, collapse it
    if (this._selectedCategoryId() === id) {
      this._selectedCategoryId.set('');
      this._selectedSubCategoryId.set('');
    } else {
      this._selectedCategoryId.set(id);
      this._selectedSubCategoryId.set('');
    }
    e?.stopPropagation();
  }

  redirectToWarranty() {
    const user = this.userService.appUser;
    if (!user?.access_token) {
      this.notificationService.showInfo('Please log in to your account to continue.');
    }
    this.router.navigateByUrl('/warranty');
  }

  subCategorySelected(id: string | undefined, e?: Event) {
    if (!id) { return; }
    // Toggle logic: if clicking same subcategory, collapse it
    if (this._selectedSubCategoryId() === id) {
      this._selectedSubCategoryId.set('');
    } else {
      this._selectedSubCategoryId.set(id);
    }
    e?.stopPropagation();
  }

  resetSelection() {
    this._selectedCategoryId.set('');
    this._selectedSubCategoryId.set('');
  }

  hideMenu() {
    this.hideMenu$.emit(true);
  }
}

